import { getPaylinksMbeUrl } from "../helpers/urls";

/**
 * Fetches whether GoDaddy branding should be disabled
 * @param {string} env
 * @param {string} storeId
 */
export async function getShouldDisableGoDaddyBranding({ env, storeId }) {
  try {
    const response = await fetch(`${getPaylinksMbeUrl(env)}/api/v1/branding?storeId=${storeId}`, {
      headers: {
        Accept: "application/json",
      },
    });

    return response.json();
  } catch (error) {
    console.error(`getShouldDisableGoDaddyBranding error: ${error}`);

    return { shouldDisableGoDaddyBranding: false };
  }
}
